import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { getApi } from "../utils/api.ts";
import { API_GET_TIMESHEET_WEEKLY_SUMMARY } from "../../config/Endpoints.js";

export const useWeeklyTimesheet = () => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const accessToken = Cookies.get("accessToken");

  const fetchTimesheet = async () => {
    try {
      setLoading(true);
      const res: any = await getApi(API_GET_TIMESHEET_WEEKLY_SUMMARY, accessToken);
      setData(res?.data?.data);
    } catch (err: any) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTimesheet();
  }, []);

  return { data, loading, error, refetch: fetchTimesheet };
};